export default __webpack_public_path__ + "static/media/achievement.23f0ef22.svg";